import type { HTMLAttributes } from 'react';
import styled from 'styled-components';
import type { ProductRegimeAdvisorModel } from 'autogen/swagger/all';
import Image from 'components/generic/Image';
import { getLargestPictureSrc } from 'helpers/imageScalingHelper';
import { breakpoint, sizes } from 'variables';

const StyledImage = styled(Image.WithScaling)`
    width: 80px;
    height: 96px;
    object-fit: cover;
    border-radius: 6px;

    ${breakpoint.up(sizes.md)} {
        width: 95px;
        height: 115px;
    }
`;

type AdvisorAvatarProps = HTMLAttributes<HTMLImageElement> & { image: ProductRegimeAdvisorModel['mainProfileImage'] };

export default function AdvisorAvatar({ image, className }: AdvisorAvatarProps) {
    const { altText, lazyLoad, imageClass } = image;
    const largestImageSrc = getLargestPictureSrc(image);

    return (
        <StyledImage
            className={`${className} ${imageClass}`}
            alt={altText}
            sizes={[[sizes.md, 95], 80]}
            loading={lazyLoad ? 'lazy' : 'eager'}
            src={largestImageSrc}
            transformType="WidthScale"
        />
    );
}
